<br>
<div class="card card-default">
    <div class="card-header title_size">
        <h2 class="card-title">Edit Department Details</h2>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <div class="card-body">

        <div class="row">
            <div class="col-md-6">


                <div class="form-group">
                    <label>Select Foreman</label><span class="error">{{Search_employee}}</span>

                    <div class="input-group">
                        <input type="search" class="form-control" placeholder="Search employee"
                            [(ngModel)]="data.department_Foreman_name"
                            (ngModelChange)="valuechange4($event);SearchEmployee();">
                        <button type="submit" class="btn  btn-default" (click)="SearchEmployee();">
                            <i class="fa fa-search"></i>
                        </button>

                    </div>

                    <div class="card card-default" *ngIf="isShownEmployee">
                        <div *ngFor="let c of employee">
                            <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)">
                                <b>{{c.employee_name}}</b>
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Select Warehouse</label><span class="error">{{Search_employee}}</span>

                    <div class="input-group">
                        <input type="search" class="form-control" placeholder="Search Warehouse"
                            [(ngModel)]="data.warehouse_name" (ngModelChange)="searchWarehouse()">
                        <button type="submit" class="btn  btn-default">
                            <i class="fa fa-search"></i>
                        </button>

                    </div>
                    <div class="card card-default" *ngIf="warehousename_search !=''">
                        <div *ngFor="let c of warehouse_dropdown">
                            <h4 *ngIf="warehousename_search === '' || c.warehouse_name.toLowerCase().includes(warehousename_search.toLowerCase())"
                                class="font" (click)="selectedWarehouse(c)">
                                <b>{{c.warehouse_name}}</b>
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Select Customer</label><span class="error">{{Search_employee}}</span>

                    <div class="input-group">
                        <ng-select [items]="customerDropdown" bindLabel="customer_name" bindValue="customer_id" (change)="selectCustomer($event)" [multiple]="true"
                            name="customer_id" id="customer_id"  dropdownPosition="bottom" [closeOnSelect]="false" [virtualScroll]="true"
                            [(ngModel)]="data.cash_customers" ></ng-select>

                    </div>
                  
                </div>


                <div class="form-group">
                    <label>Is Factory</label><br>

                    <div class="form-check ms-4">
                        <input type="checkbox" class="form-check-input" name="" id="" [(ngModel)]="data.is_factory">
                    </div>


                </div>
                <div class="form-group">
                    <label>Members</label><br>

                    <button mat-mini-fab color="primary" style="margin-left:10px ;" matTooltip="Add Check list"
                        data-toggle="modal" data-target="#modal-sm3">
                        <mat-icon>add</mat-icon>
                    </button>


                    <div *ngFor="let employee of CheckArray; let i=index;">
                        <input style="margin-top: 12px;" class="checkbox-custom" type="checkbox"
                            [value]="employee.employee_id" id="flexCheckChecked" disabled />
                        {{ employee.employee_name }}
                    </div>

                </div>
                <div class="form-group">
                    <label>Account Members</label><br>

                    <button mat-mini-fab color="primary" style="margin-left:10px ;" matTooltip="Add Check list"
                        data-toggle="modal" data-target="#accMember">
                        <mat-icon>add</mat-icon>
                    </button>


                    <div *ngFor="let employee of checkArrayacc; let i=index;">
                        <input style="margin-top: 12px;" class="checkbox-custom" type="checkbox"
                            [value]="employee.employee_id" id="flexCheckChecked" disabled />
                        {{ employee.employee_name }}
                    </div>

                </div>
                <div class="form-group">
                    <label>Helper Members</label><br>

                    <button mat-mini-fab color="primary" style="margin-left:10px ;" matTooltip="Add Check list"
                        data-toggle="modal" data-target="#helpMember">
                        <mat-icon>add</mat-icon>
                    </button>


                    <div *ngFor="let employee of checkArrayhelp ; let i=index;">
                        <input style="margin-top: 12px;" class="checkbox-custom" type="checkbox"
                            [value]="employee.employee_id" id="flexCheckChecked" disabled />
                        {{ employee.employee_name }}
                    </div>

                </div>
                <div class="form-group">
                    <label>Industry Types</label><br>

                    <button mat-mini-fab color="primary" style="margin-left:10px ;" matTooltip="Add Check list"
                        data-toggle="modal" data-target="#Industry">
                        <mat-icon>add</mat-icon>
                    </button>


                    <div *ngFor="let industry of checkArrayindustry; let i=index;">
                        <input style="margin-top: 12px;" class="checkbox-custom" type="checkbox"
                            [value]="employee.employee_id" id="flexCheckChecked" disabled />
                        {{ industry.industry_type_name }} - {{industry.estimated_time}}
                    </div>

                </div>
   
                <div class="weekdays-container mt-5">
                        <label class="required">Weekly Working Days</label>
                        <div class="weekdays-grid">
                          <div *ngFor="let day of weeKDays; let i = index" class="weekday-item">
                            <mat-checkbox [checked]="day.checked" (change)="weekSelected(i+1)">
                              {{ day.week }}
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                

                <div class="form-group mt-5">
                    <label>Public Holidays</label><br>
                    <div style="display: flex; gap: 8px;">
                        <input type="date" [(ngModel)]="newHolidayDate" class="form-control"
                            placeholder="Select date" />
                        <button type="button" class="btn btn-sm btn-primary"
                            (click)="addHoliday(newHolidayDate)">Add</button>
                    </div>
                    <select class="form-control mt-2" multiple size="4" style="margin-top:10px;">
                        <option *ngFor="let date of public_holidays; let i = index" [value]="date">
                            {{ date }}
                        </option>
                    </select>
                    <div>
                        <button type="button" class="btn btn-sm btn-danger mt-2"
                            (click)="removeSelectedHoliday()">Remove Selected</button>
                    </div>
                </div>


            </div>



            <div class="col-md-6">


                <div class="form-group">
                    <label>Work In Time</label>
                    <div class="input-group">
                        <input class="form-control" [ngxTimepicker]="picker1" [format]="24"
                            placeholder="Pick work in time" [(ngModel)]="data.work_in_time">
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fas fa-clock" [ngxTimepicker]="picker1" [format]="24"></i>
                            </span>
                        </div>
                    </div>
                    <ngx-material-timepicker #picker1></ngx-material-timepicker>
                </div>







                <div class="form-group">
                    <label>Lunch Out Time</label>
                    <div class="input-group">
                        <input class="form-control" [ngxTimepicker]="picker2" [format]="24"
                            placeholder="Pick lunch out time" [(ngModel)]="data.lunch_out_time">
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fas fa-clock" [ngxTimepicker]="picker2" [format]="24"></i>
                            </span>
                        </div>
                    </div>
                    <ngx-material-timepicker #picker2></ngx-material-timepicker>
                </div>

                <div class="form-group">
                    <label>Lunch In Time</label>
                    <div class="input-group">
                        <input class="form-control" [ngxTimepicker]="picker4" [format]="24"
                            placeholder="Pick lunch in time" [(ngModel)]="data.lunch_in_time">
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fas fa-clock" [ngxTimepicker]="picker4" [format]="24"></i>
                            </span>
                        </div>
                    </div>
                    <ngx-material-timepicker #picker4></ngx-material-timepicker>
                </div>


                <div class="form-group">
                    <label>Work Out Time</label>
                    <div class="input-group">
                        <input class="form-control" [ngxTimepicker]="picker3" [format]="24"
                            placeholder="Pick work out time" [(ngModel)]="data.work_out_time">
                        <div class="input-group-append">
                            <span class="input-group-text">
                                <i class="fas fa-clock" [ngxTimepicker]="picker3" [format]="24"></i>
                            </span>
                        </div>
                    </div>
                    <ngx-material-timepicker #picker3></ngx-material-timepicker>
                </div>


                <div class="form-group">
                    <label>Select country</label>
                    <ng-select required (close)="subInput('close')" (open)="subInput('focus')"
                        (mouseenter)="subInput('focus')" (mouseleave)="subInput('close')" [class]="subinputFocused"
                        (change)="timeZone($event)" [(ngModel)]="this.data.country_name">
                        <ng-option *ngFor="let count of country" [value]="count">
                            <img [src]="'assets/country flag icon/' + count.code + '.svg?'+count.name" width="30px">
                            {{count.name}}
                        </ng-option>
                    </ng-select>
                    <div *ngIf="!countryBool">
                        <small class="text-danger">Select a Country</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Select Time Zone</label>
                    <ng-select required (close)="subInput('close')" (open)="subInput('focus')"
                        (mouseenter)="subInput('focus')" (mouseleave)="subInput('close')" [class]="subinputFocused"
                        (change)="timeZoneSelected($event)" [(ngModel)]="this.data.timezone">
                        <ng-option *ngFor="let zone of timeZonesDropdown" [value]="zone">

                            {{zone}}
                        </ng-option>
                    </ng-select>
                    <div *ngIf="!timezoneBool">
                        <small class="text-danger">Select a Time Zone</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Lattitude</label>
                    <input type="number" class="form-control" [(ngModel)]="data.department_latitude">
                </div>


                <div class="form-group">
                    <label>Longitude</label>
                    <input type="number" class="form-control" [(ngModel)]="data.department_longitude">
                </div>

                <div class="form-group">
                    <label>Location</label>
                    <td>
                        <a class=" btn-sm edit_style space" data-toggle="modal" data-target="#modal-sm">
                            <mat-icon
                                (click)="FindLocation(data.department_latitude,data.department_longitude);">room</mat-icon>
                        </a>
                    </td>
                </div>

            </div>
            <!-- </div> -->

            <google-map *ngIf="mapLoaded" height="500px" width="100%" [center]="center" [zoom]="zoom"
                (mapClick)="onMapClick($event)">
                <map-marker *ngFor="let marker of markers" [position]="marker.position" [label]="marker.label"
                    [title]="marker.title" [options]="marker.options">
                </map-marker>



                <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true"
                        (click)="shown()">×</button>
                    <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
                </div>
            </google-map>

        </div>
        <br>
        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick();">Submit</button>
    </div>
</div>


<div class="modal fade popup_style" id="modal-sm3" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body" style="height: 490px; overflow-y: auto;">
                <br>
                <input type="text" name="table_search" class="form-control icon" placeholder="Search employees"
                    [(ngModel)]="search_name" (ngModelChange)="searchMembers();">
                <br>
                <table class="table table-striped">


                    <thead>
                        <tr>
                            <th></th>
                            <th>Add Members</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of listEmployees">
                            <td>
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" [id]="'checkboxPrimary' + employee.employee_id"
                                        [checked]="isChecked(employee)" (change)="memberList(employee)">
                                </div>
                            </td>
                            <td>{{ employee.employee_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                <button type="button" class="btn btn-default" data-dismiss="modal" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade popup_style" id="accMember" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body" style="height: 490px; overflow-y: auto;">
                <br>
                <input type="text" name="table_search" class="form-control icon" placeholder="Search employees"
                    [(ngModel)]="search_name" (ngModelChange)="searchMembers();">
                <br>
                <table class="table table-striped">


                    <thead>
                        <tr>
                            <th></th>
                            <th>Add Members</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of listEmployees">
                            <td>
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" [id]="'checkboxPrimary' + employee.employee_id"
                                        [checked]="isCheckedAcc(employee)" (change)="accmemberList(employee)">
                                </div>
                            </td>
                            <td>{{ employee.employee_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                <button type="button" class="btn btn-default" data-dismiss="modal" (click)="accCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade popup_style" id="helpMember" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body" style="height: 490px; overflow-y: auto;">
                <br>
                <input type="text" name="table_search" class="form-control icon" placeholder="Search employees"
                    [(ngModel)]="search_name" (ngModelChange)="searchMembers();">
                <br>
                <table class="table table-striped">


                    <thead>
                        <tr>
                            <th></th>
                            <th>Add Members</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of listEmployees">
                            <td>
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" [id]="'checkboxPrimary' + employee.employee_id"
                                        [checked]="isCheckedHelp(employee)" (change)="helpmemberList(employee)">
                                </div>
                            </td>
                            <td>{{ employee.employee_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                <button type="button" class="btn btn-default" data-dismiss="modal"
                    (click)="helpCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade popup_style" id="Industry" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body" style="height: 490px; overflow-y: auto;">
                <br>
                <input type="text" name="table_search" class="form-control icon" placeholder="Search employees"
                    [(ngModel)]="search_name" (ngModelChange)="searchMembers();">
                <br>
                <table class="table table-striped">


                    <thead>
                        <tr>
                            <th></th>
                            <th>Add Industry Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let industry of industryListDrop">
                            <td>
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" [id]="'checkboxPrimary' + industry._id"
                                        [checked]="isCheckedind(industry)" (change)="industryList(industry)">
                                </div>
                            </td>
                            <td>{{ industry.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                <button type="button" class="btn btn-default" data-dismiss="modal" (click)="indCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>



<!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#estimate">
  Launch demo modal
</button> -->

<!-- Modal -->
<div class="modal fade" id="estimate" tabindex="-1" role="dialog" aria-labelledby="estimate" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="estimate">Time Estimate</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">



                <div class="form-group">
                    <label for="estimateTime">Time Estimate (HH:mm:ss)</label>
                    <input id="estimateTime" class="form-control" type="text" [(ngModel)]="estimateTime"
                        (input)="validateTime(estimateTime)" placeholder="HH:mm:ss" />
                    <small *ngIf="isInvalidTime" class="text-danger">
                        Please enter time in HH:mm:ss format.
                    </small>
                </div>

                <!-- <p>Entered Time: {{ estimateTime }}</p> -->










                <!-- <input class="form-control" type="time" [(ngModel)] = "estimateTime" (ngModelChange)="estimateTimevalue($event)" >
        <small class="text-danger">{{timeError}}</small> -->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" [disabled]="isInvalidTime" (click)="selectedTimes()">Save
                    changes</button>
            </div>
        </div>
    </div>
</div>